import { useSelector } from "react-redux";
import { RootState } from "../common/redux/reducers";

export const useToaster = () =>
  useSelector((state: RootState) => state.toaster);
